import { render, staticRenderFns } from "./CMR.vue?vue&type=template&id=cb530a30&scoped=true&"
import script from "./CMR.vue?vue&type=script&lang=js&"
export * from "./CMR.vue?vue&type=script&lang=js&"
import style0 from "./CMR.vue?vue&type=style&index=0&id=cb530a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb530a30",
  null
  
)

export default component.exports